// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyACutRTXnjGYGaD4VSCVkHY4wpTSNaFdug',
    authDomain: 'assetregister-c7cb4.firebaseapp.com',
    databaseURL: 'https://assetregister-c7cb4.firebaseio.com',
    projectId: 'assetregister-c7cb4',
    storageBucket: 'assetregister-c7cb4.appspot.com',
    messagingSenderId: '733271160183',
    appId: '1:733271160183:web:a54a8a8c81cd198070dd72'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
